import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/userExperience2.webp'

export const UserExperienceBannerTwo: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'user experience'} />
)
